const ITEMS = [
  "Digital Products",
  "Craftsi Marketplace",
  "Business Solutions",
  "Local Services",
  "Technology Driven",
  "Customer First",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="mx-8 whitespace-nowrap font-heading text-lg font-medium uppercase tracking-[0.25em] text-navy/40">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-gold/60" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-gray-100 bg-white py-6"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
